import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { AddRentalDialogComponent } from '@tv3/containers/rentals/add/add-rental-dialog.component'
import { DeleteRentalOverlayComponent } from './delete-rental-overlay/delete-rental-overlay.component'
import { CopyRentalInfoDialogComponent } from './copy-rental-info-dialog/copy-rental-info-dialog.component'
import { ParentChildRentalDialogComponent } from '@tv3/containers/rentals/group/parent-child-rental-dialog/parent-child-rental-dialog.component'
import { MultiUnitRentalDialogComponent } from './group/multi-unit-rental-dialog/multi-unit-rental-dialog.component'
import { RentalGroupLabelComponent } from './group/rental-group-label/rental-group-label.component'
import { AddMultiUnitDialogComponent } from './group/add-multi-unit/add-multi-unit-dialog.component'
import { MultiUnitReservationSettingsComponent } from './group/multi-unit-reservation-settings/multi-unit-reservation-settings.component'
import { RentalToMultiUnitDialogComponent } from './group/rental-to-multi-unit-dialog/rental-to-multi-unit-dialog.component'
import { RentalSubunitsTableComponent } from './group/rental-subunits-table/rental-subunits-table.component'
import { SubunitSettingsDialogComponent } from './group/subunit-settings-dialog/subunit-settings-dialog.component'
import { RentalGroupSuccessDialogService } from './group/rental-group-success-dialog/rental-group-success-dialog.service'
import { RentalGroupSuccessDialogComponent } from './group/rental-group-success-dialog/rental-group-success-dialog.component'

const components = [
  AddRentalDialogComponent,
  DeleteRentalOverlayComponent,
  CopyRentalInfoDialogComponent,
  ParentChildRentalDialogComponent,
  MultiUnitRentalDialogComponent,
  RentalGroupLabelComponent,
  AddMultiUnitDialogComponent,
  MultiUnitReservationSettingsComponent,
  RentalToMultiUnitDialogComponent,
  RentalSubunitsTableComponent,
  SubunitSettingsDialogComponent,
  RentalGroupSuccessDialogComponent,
]

const modules = [SharedModule, CommonModule]

const services = [RentalGroupSuccessDialogService]

@NgModule({
  imports: [...modules],
  declarations: [...components],
  exports: [...components, ...modules],
  providers: [...services],
})
export class RentalsSharedModule {}
